import React from "react";

import { fadeIn, scrollToTop, setMeta } from "../helpers";

import Loading from "./Loading";
import WorkCollection from "./WorkCollection";
import ProjectContentSection from "./ProjectContentSection";

class ProjectContent extends React.Component {
  constructor(props) {
    super(props);
    this.addContent = this.addContent.bind(this);
    this.animationHandler = this.animationHandler.bind(this);
    this.splitImagesHandler = this.splitImagesHandler.bind(this);
    this.scrollToTop = scrollToTop.bind(this);

    // initial state
    this.state = {
      content: {
        title: [],
        content: [],
      },
      slug: "",
    };
  }

  addContent(slug) {
    // reset content
    const blankContent = { title: [], content: [] };
    this.setState({ content: blankContent });

    // the project fetch url
    var fetchURL = `https://wp.cghnyc.com/wp-json/cgh/project/?slug=` + this.props.slug;

    // create a new promise for the work
    const contentPromise = fetch(fetchURL);

    contentPromise
      .then(data => data.json())
      .then(data => {
        const content = data;

        this.setState({ content });
        let metaDescription = document.querySelector(".workContent--text p");
        metaDescription = metaDescription ? metaDescription.textContent : null;
        let metaImage = document.querySelector(".projectDetail img").getAttribute("src");

        setMeta("description", metaDescription);
        setMeta("image", metaImage);
        setMeta(
          "title",
          (document.title = this.state.content.title + " - Chermayeff & Geismar & Haviv")
        );

        // Update master work settings based on project JSON.
        this.props.setMaster("work", { activeCollection: content.collection });

        // Load from a project page without title set
        if (this.props.work.collectionTitle === null) {
          if (content.collection === "history") {
            this.props.setMaster("work", { collectionTitle: "Work" });
          } else {
            switch (content.type) {
              case "art-in-architecture":
                this.props.setMaster("work", { collectionTitle: "Art in Architecture" });
                break;
              case "graphic":
                this.props.setMaster("work", { collectionTitle: "Graphics" });
                break;
              case "logo":
                this.props.setMaster("work", { collectionTitle: "Logos", checkerThumbs: true });
                break;
              default:
                this.props.setMaster("work", { collectionTitle: "Work" });
            }
          }
        }

        // Load from a project page without type set
        if (this.props.work.activeType === null) {
          if (content.collection === "history") {
            this.props.setMaster("work", { activeType: "all" });
          } else {
            switch (content.type) {
              case "graphic":
                this.props.setMaster("work", { activeType: "graphics" });
                break;
              case "logo":
                this.props.setMaster("work", { activeType: "logos" });
                break;
              default:
                this.props.setMaster("work", { activeType: content.type });
            }
          }
        }

        this.animationHandler();
        this.splitImagesHandler();
      });
  }

  // For animations we do not want them to play until the video element has been scrolled to
  animationHandler() {
    const animatedMP4s = document.querySelectorAll(".video--animation");
    const animatedGIFs = document.querySelectorAll(".image__animatedGif");
    const onScreenAmount = 0.75;

    // scroll event listener for animated gifs
    var animatedGIFPlayCheck = e => {
      var gifsPlaying = 0;

      for (var i = 0; i < animatedGIFs.length; i++) {
        let gif = animatedGIFs[i];
        let gifRect = gif.getBoundingClientRect();

        if (gif.hasAttribute("played")) {
          gifsPlaying++;
          continue;
        }

        // Play the gif if it is at 3/4 halfway on screen. We do this by removing then re-adding the
        // src attribute once we want it to play, and removing the 0% opacity with CSS.
        if (
          gifRect.top < window.innerHeight - gifRect.height * onScreenAmount &&
          !gif.hasAttribute("played")
        ) {
          let cachedSrc = gif.getAttribute("src");
          let cachedHeight = gif.offsetHeight;

          gif.setAttribute("height", cachedHeight);
          gif.setAttribute("src", "");

          gif.setAttribute("src", cachedSrc);

          // Delay slightly to avoid rendering jumpiness
          setTimeout(() => {
            gif.removeAttribute("height");
          }, 50);

          gifsPlaying++;

          // Set last to avoid CSS rendering issues
          gif.setAttribute("played", true);
        }
      }

      // If all of the animations are already playing remove the event listener
      if (gifsPlaying === animatedGIFs.length) {
        window.removeEventListener("scroll", animatedGIFPlayCheck);
      }
    };

    // scroll event listener for mp4s
    var animatedMP4PlayCheck = e => {
      var videosPlaying = 0;

      for (var i = 0; i < animatedMP4s.length; i++) {
        let animation = animatedMP4s[i];
        let animationRect = animation.getBoundingClientRect();

        // Play the video if it is at 3/4 halfway on screen
        if (
          animationRect.top < window.innerHeight - animationRect.height * onScreenAmount &&
          animation.paused &&
          !animation.hasAttribute("played")
        ) {
          animation.play();
          animation.setAttribute("played", true);
          videosPlaying++;

          // If the video doesn't loop force it to go to the last frame after it's done.
          // For some reason Safari resets to first frame if a display goes to sleep then wakes up
          // when on the page. This fixes that.
          let animationLength = animation.duration;

          if (!animation.hasAttribute("loop")) {
            setTimeout(() => {
              animation.currentTime = animationLength;
            }, animationLength * 1000);
          }
        }
      }

      // If all of the animations are already playing remove the event listener
      if (videosPlaying === animatedMP4s.length) {
        window.removeEventListener("scroll", animatedMP4PlayCheck);
      }
    };

    // We need to manually set the height of the mp4s because of a bug in IE,
    // as well as Chrome when displaying flex. Hardcoding the height seems to make video elements
    // much easier to deal with.
    var animatedMP4HeightCheck = e => {
      for (var i = 0; i < animatedMP4s.length; i++) {
        let animation = animatedMP4s[i];
        let animationMaxHeight = animation.getAttribute("maxheight");
        let animationMaxWidth = animation.getAttribute("maxwidth");
        let animationRatio = animationMaxHeight / animationMaxWidth;

        // unset before checking detected width, otherwise it won't get bigger, only smaller
        animation.style.height = null;
        animation.style.width = null;

        let animationDetectedWidth = animation.offsetWidth;

        // if the video is floated it will still think it's width is the size of the parent frame
        // to get around this we pick up the max-width of the source file and compare it to the
        // detected width to see what the effective width is.
        // If the max width (the source width) is slimmer than the detected width, we inline
        // that as well.
        if (animationDetectedWidth > animationMaxWidth) {
          animation.style.height = (animationMaxWidth * animationRatio).toFixed(2) + "px";
          animation.style.width = animationMaxWidth + "px";
        } else {
          animation.style.height = (animationDetectedWidth * animationRatio).toFixed(2) + "px";
          animation.style.width = "";
        }
      }
    };

    // If there are animated MP4s, run the listeners
    if (animatedMP4s.length >= 1) {
      // Run each time an animated MP4 becomes ready to play, then add an event listener
      for (var i = animatedMP4s.length - 1; i >= 0; i--) {
        let mp4 = animatedMP4s[i];

        // do it once since for some reason the event listener is broken on safari ios
        setTimeout(() => {
          animatedMP4HeightCheck();
          animatedMP4PlayCheck();
        }, 250);

        // For non-iPhones
        mp4.addEventListener("loadeddata", () => {
          // Delay this slightly, if the videos are cached they can play immediately and
          // we want to give it a moment to paint before checking the position
          setTimeout(() => {
            animatedMP4HeightCheck();
            animatedMP4PlayCheck();
          }, 250);
        });
      }

      window.addEventListener("scroll", animatedMP4PlayCheck);
      window.addEventListener("resize", animatedMP4HeightCheck);
    } else {
      // If there are no animated MP4s on the page, remove the listeners (should they exist)
      window.removeEventListener("resize", animatedMP4HeightCheck);
      window.removeEventListener("scroll", animatedMP4PlayCheck);
    }

    // If there are animated GIFs, run once and add the listener
    if (animatedGIFs.length >= 1) {
      // Delay slightly to avoid premature firing
      setTimeout(() => {
        animatedGIFPlayCheck();
      }, 500);

      window.addEventListener("scroll", animatedGIFPlayCheck);
    } else {
      window.removeEventListener("scroll", animatedGIFPlayCheck);
    }
  }

  // The split image layouts (1x2 or 2x1) need special handling to resize the container
  // based on the height of the two stacked graphics that will determine the container height.
  // We are hardcoding the gutter here (the margin) because of difficulties examining margin values
  // in React, and I'd rather not add an additional React plugin just for this one check.
  splitImagesHandler() {
    const splitImageLayouts = document.querySelectorAll(".workContent--images__layout-splitImages");

    if (splitImageLayouts.length === 0) {
      // no split image layouts, remove and event listener and exit
      // eslint-disable-next-line no-use-before-define
      window.removeEventListener("resize", splitImagesCheck);
      return;
    } else {
      // has split image layouts
      var splitImagesCheck = e => {
        for (var i = 0; i < splitImageLayouts.length; i++) {
          let thisLayout = splitImageLayouts[i];
          let thisLayoutImageContainer = thisLayout.querySelector(".images--row");
          let thisLayoutHeightChecks = thisLayout.querySelectorAll(".js-splitImages--heightCheck");
          let thisLayoutCalculatedHeight = 0;
          let heightTotal = 0;
          let responsiveLayout = false;
          let windowWidth = window.innerWidth;
          let gutterMobile = 15;
          let gutterDesktop = 30;
          let gutterUsed = 0;
          let safetyPixel = 1; // because of fractional pixel issues it's best to add one more pixel

          if (thisLayout.classList.contains("workContent--images__responsive")) {
            responsiveLayout = true;
          }

          // Iterate over each image that will add to the container height
          // and add it to the total for the container.
          for (let ii = 0, length1 = thisLayoutHeightChecks.length; ii < length1; ii++) {
            let thisChildHeight = thisLayoutHeightChecks[ii].offsetHeight;

            // If any images have undetected or 0 heights they are not finished loading
            // and we want to stop early then re-run it until all are defined
            // so it gets the correct heights.
            if (thisChildHeight === undefined || thisChildHeight === 0) {
              setTimeout(() => {
                this.splitImagesHandler();
              }, 50);

              return;
            }

            heightTotal += thisLayoutHeightChecks[ii].offsetHeight;
          }

          if (windowWidth > 640) {
            // Desktop resolution
            gutterUsed = gutterDesktop;
          } else if (!responsiveLayout) {
            // Mobile resolution, image layouts that don't stack on mobile
            gutterUsed = gutterMobile;
          } else {
            // Mobile resolution, images stack, so we should not set the height of the container here
            thisLayoutImageContainer.style.height = "";
            return;
          }

          thisLayoutCalculatedHeight = heightTotal + gutterUsed + safetyPixel + "px";
          thisLayoutImageContainer.style.height = thisLayoutCalculatedHeight;
        }
      };

      // Run once after a quarter second to give the layout a moment to settle
      setTimeout(() => {
        splitImagesCheck();
      }, 250);

      window.addEventListener("resize", splitImagesCheck);
    }
  }

  componentWillMount() {
    this.scrollToTop();
    this.addContent();
  }

  componentDidMount() {
    fadeIn();
  }

  componentDidUpdate(prevProps, prevState) {
    fadeIn();

    // project changed
    if (this.props.slug !== prevProps.slug) {
      this.addContent();
      this.scrollToTop();
    }
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = null;
    document.body.classList.remove("projectPage__colorBackground");
  }

  render() {
    if (this.state.content.content.length === 0) {
      return <Loading />;
    } else {
      document.querySelector("main").classList.remove("main--loading");

      if (this.state.content.backgroundColor) {
        document.body.style.backgroundColor = this.state.content.backgroundColor;
        document.body.classList.add("projectPage__colorBackground");
      } else {
        document.body.style.backgroundColor = null;
        document.body.classList.remove("projectPage__colorBackground");
      }

      return (
        <div className="js-fade__slow js-fadeMeIn">
          <article className="projectDetail">
            {this.state.content.noTitle !== true && (
              <header className="entry-header">
                <h1
                  className="entry-title"
                  dangerouslySetInnerHTML={{ __html: this.state.content.title }}
                />
              </header>
            )}
            <div className="content workContent--container">
              {Object.keys(this.state.content.content).map(key => (
                <ProjectContentSection
                  details={this.state.content.content[key]}
                  isMobile={this.props.isMobile}
                  key={key}
                  projectTitle={this.state.content.title}
                />
              ))}
            </div>
          </article>
          <WorkCollection
            pageType={this.props.pageType}
            params={this.props.params}
            setMaster={this.props.setMaster.bind(this)}
            sortBy={this.props.work.sortBy}
            work={this.props.work}
          />
        </div>
      );
    }
  }
}

export default ProjectContent;



/** WEBPACK FOOTER **
 ** ./src/components/ProjectContent.js
 **/